
////////////////////////////////////
// damageservice tabs
function initDamageserviceTabs() {
    
    if ($(".damageservice__tabs").length > 0) {

        $(".damageservice__tabs").on("touchstart", dragMouseDown);
        $(".damageservice__tabs").on("mousedown", dragMouseDown);
        
        $(".damageservice__tabs").find(".damageservice__tab").on("click", function(){
            
            $(".damageservice__content").removeClass("active");
            $(".damageservice__tab").removeClass("active");
            
            $(this).addClass("active");
            
            var cId = $(this).attr("data-content");
            var $content = $("#" + cId);
            if($content){
                $content.addClass("active");
            }

            updateDamageserviceTabs();
        });
        $(".damageservice__tabs").find(".damageservice__tab").on("keydown", handleKeyDownForClick);
        
        $(".damageservice__tabs").find(".damageservice__tab").each(function(){
            var hash = window.location.hash.substring(1);
            var anchor = $(this).attr("data-anchor");

            if(hash == anchor){
                $(this).trigger("click");

                var offset = $(this).offset().top - 50;
                $('html, body').animate({
                    scrollTop: offset
                }, 500);
            }
        });

        updateDamageserviceTabs();
    }
}

function updateDamageserviceTabs() {

    const $damageNavContainer = $(".damageservice__navigation");
    const $activeDamageTab = $(".damageservice__tab.active");
    if($activeDamageTab){
        
        /*
        console.log("$activeDamageTab.width():" + $activeDamageTab.width());
        console.log("$activeDamageTab.offset().left:" + $activeDamageTab.offset().left);
        console.log("$damageNavContainer.offset().left:" + $damageNavContainer.offset().left);
        console.log("$damageNavContainer.width():" + $damageNavContainer.width());
        */

        if($activeDamageTab.offset().left > $damageNavContainer.offset().left){
            if($activeDamageTab.offset().left < ($damageNavContainer.offset().left + $damageNavContainer.width() - $activeDamageTab.width())){
                //tab button is visible - cancel pos update
                return;
            }
        }
        
        const $lastTab = $(".damageservice__tabs").children().last();
        const dNavFullWidth = $lastTab.offset().left + $lastTab.width();
        const minMl = -(dNavFullWidth - $damageNavContainer.width());
        const adtLeft = $activeDamageTab.offset().left - $damageNavContainer.offset().left;
        /*
        console.log("dNavFullWidth:" + dNavFullWidth);
        console.log("minMl:" + minMl);
        console.log("adtLeft:" + adtLeft);
        */

        var ml = (-adtLeft) + 50;
        if(ml > 0){
            ml = 0;
        }
        if(ml < minMl){
            ml = minMl;
        }

        if(dNavFullWidth < $damageNavContainer.width()){
            ml = 0;
        }

        //console.log("ml:" + ml);
        $("#damageserviceTabs").css("margin-left", ml + "px");
    }
}

